export enum ErrorsAPI {
  UNAUTHORIZED_1 = 'core.01',
  UNAUTHORIZED_2 = 'core.02',
}